import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isHomeServicesDropdownOpen, setIsHomeServicesDropdownOpen] = useState(false); // New state for Home Services dropdown

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleHomeServicesDropdown = () => {
    setIsHomeServicesDropdownOpen(!isHomeServicesDropdownOpen);
  };

  return (
    <div>
      <div className="w-full h-24 border-b border-slate-100 flex justify-between items-center px-8">
        <Link to="/">
          <img
            src="/adoptlogo.png"
            alt="Logo"
            className="h-[80px] w-28 cursor-pointer"
          />
        </Link>

        <div className="lg:hidden flex items-center">
          <button onClick={toggleMobileMenu} className="text-3xl">
            &#8801;
          </button>
        </div>

        <div className="hidden lg:flex items-center gap-8">
          <div className="relative group">
            <Link to="/" className="text-2xl font-bold hover:border-2 border-orange-500 rounded-xl ">
              Home Services
            </Link>

            <div className="hidden group-hover:flex absolute right-0 top-full bg-blue-900 text-white p-8 w-screen  mx-auto shadow-md z-50">
              <div className="grid grid-cols-3 gap-8 max-w-screen-xl mx-auto">
                <div>
                  <h2 className="text-lg font-semibold text-gray-300 mb-4">
                    Home Services
                  </h2>
                  <ul className="space-y-4">
                    <Link to="/grooming" className="flex items-center gap-3">
                      <img
                        src="//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__grooming-icon.svg"
                        alt="Pet Grooming"
                        className="h-8 w-8"
                      />
                      <span className="text-lg">Pet Grooming</span>
                    </Link>
                    <Link to="vet" className="flex items-center gap-3">
                      <img
                        src="//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__vet-icon.svg"
                        alt="Consult a Vet"
                        className="h-8 w-8"
                      />
                      <span className="text-lg">Consult a Vet</span>
                    </Link>
                    <Link to="training" className="flex items-center gap-3">
                      <img
                        src="//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__training-icon.svg"
                        alt="Dog Training"
                        className="h-8 w-8"
                      />
                      <span className="text-lg">Dog Training</span>
                    </Link>
                    <Link to="walking" className="flex items-center gap-3">
                      <img
                        src="//dm6g3jbka53hp.cloudfront.net/static-images/home-page_book-services-second-section-dog-walking-icon.svg"
                        alt="Dog Walking"
                        className="h-8 w-8"
                      />
                      <span className="text-lg">Dog Walking</span>
                    </Link>
                    <Link to="adopt" className="flex items-center gap-3">
                      <img
                        src="//dm6g3jbka53hp.cloudfront.net/static-images/homepage__services-options__adopt-icon.svg"
                        alt="Adopt a Pet"
                        className="h-8 w-8"
                      />
                      <span className="text-lg">Adopt a Pet</span>
                    </Link>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <Link to="shop" className="flex items-center gap-2">
            <img src="/cartlogo.png" alt="Cart" className="h-8 w-8" />
            <p className="font-bold text-2xl">Shop</p>
          </Link>

          <Link
            to="/login"
            className="font-bold bg-orange-600 w-24 text-white text-center text-xl rounded-xl"
          >
            Login
          </Link>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="lg:hidden flex flex-col items-center bg-white w-full py-4 border-t border-slate-200">
          <button
            onClick={toggleHomeServicesDropdown}
            className="text-xl font-semibold py-2"
          >
            Home Services
          </button>

          {isHomeServicesDropdownOpen && (
            <div className="flex flex-col items-start px-4 py-2 bg-blue-900 text-white w-full">
              <Link to="/grooming" className="py-2">
                Pet Grooming
              </Link>
              <Link to="vet" className="py-2">
                Consult a Vet
              </Link>
              <Link to="training" className="py-2">
                Dog Training
              </Link>
              <Link to="walking" className="py-2">
                Dog Walking
              </Link>
              <Link to="adopt" className="py-2">
                Adopt a Pet
              </Link>
            </div>
          )}

          <Link to="shop" className="text-xl font-semibold py-2">
            Shop
          </Link>
          <Link
            to="/login"
            className="bg-orange-600 w-24 text-white text-center text-xl rounded-xl py-2 mt-4"
          >
            Login
          </Link>
        </div>
      )}
    </div>
  );
};

export default Navbar;
